import { date } from 'quasar'
import moment from 'moment'
import ValidateGlobal from './../ValidateGlobal.js'
import ServiceGlobal from './../InputsServiceGlobal.js'
import FirestoreUtils from 'src/plugins/Utils/FirestoreUtils'
import { firebase } from '@firebase/app'
import '@firebase/firestore'
const { Timestamp } = firebase.firestore
export default {
  mixins: [ValidateGlobal, ServiceGlobal],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: Object
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    },
    originModel: {
      type: Object
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data () {
    return {
      value: date.formatDate(this.modelProps && this.modelProps instanceof Timestamp ? this.modelProps.toDate() : '', this.config.format ? this.config.format : this.$store.state.config.defaultDateFormat),
      rawDate: date.formatDate(this.modelProps && this.modelProps instanceof Timestamp ? this.modelProps.toDate() : '', 'YYYY/MM/DD'),
      range: '',
      closePopup: false,
      innerModel: null
    }
  },
  created () {
    if (!this.R.isNil(this.value) && !(this.value instanceof Timestamp) && typeof this.value === 'object') {
      let converted = FirestoreUtils.convertJsonToTimetamp(this.value)
      this.value = date.formatDate(converted instanceof Timestamp ? converted.toDate() : '', this.config.format ? this.config.format : this.$store.state.config.defaultDateFormat)
    }
    let vm = this
    vm.config.format = vm.config.format ? vm.config.format : vm.$store.state.config.defaultDateFormat
    // eslint-disable-next-line
    let momentInternal = moment
    // eslint-disable-next-line no-eval
    vm.range = eval(vm.config.range)
  },
  watch: {
    rawDate (newVl, oldVl) {
      // RawDate from date picker quasar always YYYY/MM/DD
      if (!newVl || this._.isEmpty(newVl)) {
        this.$emit('input', null)
        return
      }
      this.$emit('input', Timestamp.fromDate(new Date(moment.utc(newVl, 'YYYY/MM/DD').format())))
      this.innerModel = this._.cloneDeep(this.$refs['qdate'].innerModel)
      this.value = date.formatDate(newVl, this.config.format ? this.config.format : this.$store.state.config.defaultDateFormat)
      let newVlMoment = moment(newVl, 'YYYY/MM/DD')
      let oldVlMoment = moment(oldVl, 'YYYY/MM/DD')
      this.closePopup = oldVl ? (newVlMoment.date() !== oldVlMoment.date() ? true : newVlMoment.month() !== oldVlMoment.month() || newVlMoment.year() !== oldVlMoment.year()) : newVlMoment.month() + 1 === this.innerModel.month && newVlMoment.year() === this.innerModel.year
    }
  }
}
